export const ApiDef_OrderConfiguration = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map